import Api from "@/services/apiService";

class NotificationItemsApi {
  markUnread(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/notification/items/${id}/mark_unread`, {}, Api.authHeaders()
    );
  }

  markRead(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/notification/items/${id}/mark_read`, {}, Api.authHeaders()
    );
  }

  markAllRead(companyId) {
    return Api.patchRequest(
      `companies/${companyId}/notification/items/mark_all_read`, {}, Api.authHeaders()
    );
  }

  unreadCount(companyId) {
    return Api.getRequest(
      `companies/${companyId}/notification/items/unread_count`,
      {},
      Api.authHeaders(),
      { skipErrorNotification: true }
    );
  }

  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/notification/items`,
      params,
      Api.authHeaders()
    );
  }
}

export default new NotificationItemsApi();
